module.exports = __webpack_public_path__ + "static/media/ie.16bd1441.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ie.svg
// module id = 147
// module chunks = 0